import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { Toast } from "../../../CustomComponent/toast";
import LoadingPage from "../../../Components/layouts/loading";
import { titleCaseChange } from "../../../Components/Functions/changeFirstLetterUpperCase";

const tableHead = [
  "Sr.",
  "Business name",
  "Email",
  "Contact Number",
  "Products",
  "state",
  "status",
  "Actions",
];

const AllVendorTable = ({ vendor = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

  const [productListData, setProductListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openId, setOpenId] = useState(null); // ✅ Controls popup for row

  const goToView = (id) => {
    navigate(`/purchase-vendor-management/view-vendor/${id}`);
  };

  const handleHover = (id) => {
    if (openId === id) {
      setOpenId(null); // ✅ Close popup if same row hovered again
      return;
    }

    performRequest("GET", `vendor/getVendorById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setProductListData(res?.data?.vendorDealsInMaterial || []);
          setOpenId(id); // ✅ Show popup for selected row
        } else {
          Toast("error", "Error while getting Vendor!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  if (loading) return <LoadingPage />;

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {vendor.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{titleCaseChange(item?.businessName) || "N/A"}</td>
                <td>{item?.contactPersonEmail || "N/A"}</td>
                <td>{titleCaseChange(item?.contactPersonPhone) || "N/A"}</td>

                {/* ✅ Button + Popup inside same TD */}

                <td
                  style={{ position: "relative" }}
                  onMouseLeave={() => setOpenId(null)} // ✅ Close when mouse leave
                >
                  <span
                    className="badge bg-azure text-azure-fg"
                    onMouseEnter={() => handleHover(item?.id)}
                    style={{ cursor: "pointer" }}
                  >
                    Product List
                  </span>

                  {/* ✅ Popup only for this row */}
                  {openId === item?.id && (
                    <div
                      style={{
                        position: "absolute",
                        top: "35px",
                        left: "0",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        padding: "10px",
                        minWidth: "220px",
                        zIndex: 1000,
                        boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
                      }}
                    >
                      <b>Products:</b>
                      <ul style={{ paddingLeft: "18px", marginTop: "5px" }}>
                        {productListData?.length > 0 ? (
                          productListData.map((p, i) => (
                            <li key={i}>{p?.item || "Material"}</li>
                          ))
                        ) : (
                          <li>No materials found</li>
                        )}
                      </ul>
                      {item?.customDeal && (
                        <div>
                          <b>Custom items:</b>
                          <ul>
                            <li>{item?.customDeal}</li>
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </td>

                <td>{titleCaseChange(item?.state) || "N/A"}</td>

                <td>
                  {item?.isBlacklisted ? (
                    <span className="badge bg-red fs-6 text-white">
                      Blacklisted
                    </span>
                  ) : (
                    <span class="badge bg-lime text-lime-fg">Active</span>
                  )}
                </td>

                <td>
                  <CustomViewButton onClick={() => goToView(item.id)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllVendorTable;
